import React, { useState } from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import useSignup from 'shared/screens/Signup/useSignup';
import { SignUpWrapper } from './common/SignUpWrapper';
import { SignUpForm } from './SignUpForm';
import { isHri } from 'shared/utils/targetApplication';
import { onPressHelp } from 'shared/utils/redirectionHelp';

const Signup = props => {
  const [showPassword, setShowPassword] = useState(false);

  const { formikValidation, handleCheckBoxToggle, getStatusMessage, isLoading, postSignupData } = useSignup();
  const { values, errors, status, handleSubmit, setFieldValue, handleBlur, handleChange } = formikValidation;
  const { isModal, isLandingPage, title, termsAndConditionsUrl, privacyPolicyUrl, withScroll } = props;

  const showPasswordToggleHandle = () => {
    setShowPassword(!showPassword);
  };

  return (
    <SignUpWrapper {...props} showSpinner={false}>
      <SignUpForm
        values={values}
        errors={errors}
        status={status}
        handleSubmit={handleSubmit}
        setFieldValue={setFieldValue}
        handleBlur={handleBlur}
        handleChange={handleChange}
        handleCheckBoxToggle={handleCheckBoxToggle}
        getStatusMessage={getStatusMessage}
        title={title}
        termsAndConditionsUrl={termsAndConditionsUrl}
        privacyPolicyUrl={privacyPolicyUrl}
        onPressHelp={onPressHelp}
        showPassword={showPassword}
        showPasswordToggleHandle={showPasswordToggleHandle}
        isModal={isModal}
        isLandingPage={isLandingPage}
        clientText={getText(TEXT_KEY.CLIENT_TITLE)}
        clientFurtherInfoText={getText(TEXT_KEY.RECEIVE_FURTHER_INFO)}
        requireName={!isHri}
        isLoading={isLoading}
        postSignupData={postSignupData}
        withScroll={withScroll}
      />
    </SignUpWrapper>
  );
};

Signup.AsModalProps = {
  dialogClassName: 'gtp-modal-signup',
};

export default Signup;

